import {
  FileMultipleStroke,
  Pencil1Stroke,
  PlusStroke,
  PrinterStroke,
  Search1Stroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { Lineicons } from '@lineiconshq/react-lineicons';
import { AritoActionBar, AritoActionButton, AritoIcon, AritoMenuButton } from '@/components/custom/erp';
import { usePhieuChiSearchContext } from '../context';

interface ActionBarProps {
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  onPrint?: () => void;
  onSearch?: () => void;
  onRefresh?: () => void;
  isEditDisabled?: boolean;
}

export default function ActionBar({
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  onPrint,
  onSearch,
  onRefresh,
  isEditDisabled = true
}: ActionBarProps) {
  const { exportToExcel, canExport, isExporting } = usePhieuChiSearchContext();
  return (
    <AritoActionBar titleComponent={<h1 className='text-xl font-bold'>Phiếu chi tiền</h1>}>
      <AritoActionButton title='Thêm' icon={PlusStroke} onClick={onAdd} />
      <AritoActionButton title='Sửa' icon={Pencil1Stroke} onClick={onEdit} disabled={isEditDisabled} />
      <AritoActionButton title='Xóa' icon={Trash3Stroke} onClick={onDelete} disabled={isEditDisabled} />
      <AritoActionButton title='Sao chép' icon={FileMultipleStroke} onClick={onCopy} disabled={isEditDisabled} />
      <AritoActionButton title='Tìm kiếm' icon={Search1Stroke} onClick={onSearch} variant='primary' />
      <AritoMenuButton
        icon={<Lineicons aria-hidden='true' icon={PrinterStroke} size={18} />}
        title='In ấn'
        items={[
          {
            title: 'Phiếu chi tiền mặt',
            icon: <AritoIcon icon={20} />,
            onClick: onPrint
          },
          {
            title: 'Phiếu chi tiền mặt (ngoại tệ)',
            icon: <AritoIcon icon={20} />,
            onClick: onPrint,
            group: 0
          },
          {
            title: 'Phiếu chi tiền mặt 2 liên',
            icon: <AritoIcon icon={20} />,
            onClick: onPrint,
            group: 0
          },
          {
            title: 'Phiếu chi tiền mặt 2 liên (ngoại tệ)',
            icon: <AritoIcon icon={20} />,
            onClick: onPrint,
            group: 0
          },
          {
            title: 'Phiếu chi tiền mặt (song ngữ)',
            icon: <AritoIcon icon={20} />,
            onClick: onPrint,
            group: 1
          },
          {
            title: 'Phiếu chi tiền mặt tiền (ngoại tệ, song ngữ)',
            icon: <AritoIcon icon={20} />,
            onClick: onPrint,
            group: 1
          },
          {
            title: 'Chứng từ hạch toán',
            icon: <AritoIcon icon={20} />,
            onClick: onPrint,
            group: 2
          },
          {
            title: 'Chứng từ hạch toán (ngoại tệ)',
            icon: <AritoIcon icon={20} />,
            onClick: onPrint,
            group: 2
          },
          {
            title: 'Chứng từ hạch toán (song ngữ)',
            icon: <AritoIcon icon={20} />,
            onClick: onPrint,
            group: 3
          },
          {
            title: 'Chứng từ hạch toán (ngoại tệ, song ngữ)',
            icon: <AritoIcon icon={20} />,
            onClick: onPrint,
            group: 3
          }
        ]}
      />

      <AritoMenuButton
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefresh,
            group: 1
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 1
          },
          {
            title: 'In nhiều',
            icon: <AritoIcon icon={883} />,
            onClick: () => {},
            group: 2
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: exportToExcel,
            disabled: !canExport || isExporting,
            loading: isExporting,
            loadingTitle: 'Đang kết xuất...',
            group: 2
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: () => {},
            group: 3
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: () => {},
            group: 3
          }
        ]}
      />
    </AritoActionBar>
  );
}
